/**
 * Utilitário de máscara e validação para data brasileira DD/MM/AAAA.
 */

/** Aplica máscara enquanto o usuário digita. Aceita entrada com ou sem barras. */
export const maskBRDate = (value) => {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

/** Valida se uma string DD/MM/AAAA é uma data real (dia/mês existentes, ano razoável). */
export const isValidBRDate = (value) => {
  if (!value || typeof value !== 'string') return false;
  const m = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return false;
  const d = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const y = parseInt(m[3], 10);
  if (mo < 1 || mo > 12) return false;
  if (d < 1 || d > 31) return false;
  if (y < 1900 || y > 2100) return false;
  const dt = new Date(y, mo - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
};

/** Converte ISO/qualquer string para DD/MM/AAAA (best effort). */
export const toBRDate = (value) => {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;
  const digits = String(value).replace(/\D/g, '');
  if (digits.length === 8) return maskBRDate(digits);
  const dt = new Date(value);
  if (!isNaN(dt.getTime())) {
    const d = String(dt.getDate()).padStart(2, '0');
    const mo = String(dt.getMonth() + 1).padStart(2, '0');
    return `${d}/${mo}/${dt.getFullYear()}`;
  }
  return String(value);
};
